/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiBaseAlertStatusConf } from './InternalApiBaseAlertStatusConf';
import {
    InternalApiBaseAlertStatusConfFromJSON,
    InternalApiBaseAlertStatusConfFromJSONTyped,
    InternalApiBaseAlertStatusConfToJSON,
    InternalApiBaseAlertStatusConfToJSONTyped,
} from './InternalApiBaseAlertStatusConf';

/**
 * a base for custom screening alert status
 * @export
 * @interface InternalApiBaseScreeningAlertStatus
 */
export interface InternalApiBaseScreeningAlertStatus {
    /**
     * 
     * @type {string}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    textName: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    startTime: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    enabledScreening: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    enabledMonitoring: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    enabledBridge?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    enabledManual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    isFinal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    isGoodlistable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    isImportant: boolean;
    /**
     * 
     * @type {InternalApiBaseAlertStatusConf}
     * @memberof InternalApiBaseScreeningAlertStatus
     */
    _configuration: InternalApiBaseAlertStatusConf;
}

/**
 * Check if a given object implements the InternalApiBaseScreeningAlertStatus interface.
 */
export function instanceOfInternalApiBaseScreeningAlertStatus(value: object): value is InternalApiBaseScreeningAlertStatus {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('textName' in value) || value['textName'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('enabledScreening' in value) || value['enabledScreening'] === undefined) return false;
    if (!('enabledMonitoring' in value) || value['enabledMonitoring'] === undefined) return false;
    if (!('isFinal' in value) || value['isFinal'] === undefined) return false;
    if (!('isGoodlistable' in value) || value['isGoodlistable'] === undefined) return false;
    if (!('isImportant' in value) || value['isImportant'] === undefined) return false;
    if (!('_configuration' in value) || value['_configuration'] === undefined) return false;
    return true;
}

export function InternalApiBaseScreeningAlertStatusFromJSON(json: any): InternalApiBaseScreeningAlertStatus {
    return InternalApiBaseScreeningAlertStatusFromJSONTyped(json, false);
}

export function InternalApiBaseScreeningAlertStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBaseScreeningAlertStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'textName': json['textName'],
        'startTime': (new Date(json['startTime'])),
        'enabledScreening': json['enabledScreening'],
        'enabledMonitoring': json['enabledMonitoring'],
        'enabledBridge': json['enabledBridge'] == null ? undefined : json['enabledBridge'],
        'enabledManual': json['enabledManual'] == null ? undefined : json['enabledManual'],
        'isFinal': json['isFinal'],
        'isGoodlistable': json['isGoodlistable'],
        'isImportant': json['isImportant'],
        '_configuration': InternalApiBaseAlertStatusConfFromJSON(json['configuration']),
    };
}

export function InternalApiBaseScreeningAlertStatusToJSON(json: any): InternalApiBaseScreeningAlertStatus {
    return InternalApiBaseScreeningAlertStatusToJSONTyped(json, false);
}

export function InternalApiBaseScreeningAlertStatusToJSONTyped(value?: InternalApiBaseScreeningAlertStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'textName': value['textName'],
        'startTime': value['startTime'].toISOString(),
        'enabledScreening': value['enabledScreening'],
        'enabledMonitoring': value['enabledMonitoring'],
        'enabledBridge': value['enabledBridge'],
        'enabledManual': value['enabledManual'],
        'isFinal': value['isFinal'],
        'isGoodlistable': value['isGoodlistable'],
        'isImportant': value['isImportant'],
        'configuration': InternalApiBaseAlertStatusConfToJSON(value['_configuration']),
    };
}

